import type { TFunction } from 'i18next';
import type { SurveyTemplateVersion } from '../../../api/workEnvironmentTypes';

export const templateVersionQuestions = (version: SurveyTemplateVersion) =>
  version.factors.flatMap((factor) => factor.questions);

/** «Risikofaktorer og spørsmål, versjon 3 (34 spørsmål) – anbefalt» */
export const templateVersionLabel = (version: SurveyTemplateVersion, t: TFunction) => {
  const label = t('surveyCreation.setup.hmsTemplate', {
    version: version.version,
    count: templateVersionQuestions(version).length,
  });
  return version.recommended ? t('surveyCreation.setup.hmsRecommended', { label }) : label;
};

const defaultVersion = (versions: SurveyTemplateVersion[]) =>
  versions.find((version) => version.recommended) ?? versions[0];

/** HR recommends the newest version they have made available, so it is chosen unless the leader picks another */
export const defaultTemplateVersion = (versions: SurveyTemplateVersion[]) =>
  defaultVersion(versions)?.id;

/** How many questions the team answers in a new survey, or nothing before the versions are known */
export const recommendedQuestionCount = (versions: SurveyTemplateVersion[] | undefined) => {
  const version = versions && defaultVersion(versions);
  return version ? templateVersionQuestions(version).length : null;
};
